var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F7F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 15.3333L18.5 20.6666V28.6666C18.5 36.0666 23.62 42.9866 30.5 44.6666C37.38 42.9866 42.5 36.0666 42.5 28.6666V20.6666L30.5 15.3333ZM30.5 29.9866H39.8333C39.1267 35.4799 35.46 40.3733 30.5 41.9066V29.9999H21.1667V22.3999L30.5 18.2533V29.9866Z",
    fill: "#0516C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.6555eeefea0cae2059d8699a8c2623e9.svg";
export { ForwardRef as ReactComponent };